
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/csr",
      function () {
        return require("private-next-pages/csr.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/csr"])
      });
    }
  